module.exports = __webpack_public_path__ + "media/images/pc/top/recommend-plan-text-wedding1-4e8295a08dee400c2c40534b12e91cde.png";